'use client';
/* Built In Imports */
/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Divider, Icon, Portal, Text, useBreakpointValue } from '@chakra-ui/react';

import { format } from 'date-fns';
import parser from 'html-react-parser';
import { FaFacebook, FaLinkedin, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { FiClock } from 'react-icons/fi';
import { GrMail } from 'react-icons/gr';
import { IoLocationOutline } from 'react-icons/io5';
import { PiCurrencyInrBold } from 'react-icons/pi';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
/* Internal Imports */
/* Components */
import GoogleMap from '@app-ps/Components/Embeds/GoogleMap';
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import config from '@config';
import { useEffect } from 'react';
/* Services */

/**
 * Renders the Program Details component
 *@param {string} isScheduled
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} ProgramDetails component
 */

const ProgramDetails = ({
  sectionContent,
  pDetails,
  fullDetails,
  isScheduled,
  region,
  lang,
}) => {
  const startDate = pDetails.samskriti.startdate;
  const finalDate = pDetails.samskriti.enddate;
  // console.log('startDate0', startDate, finalDate);
  // console.log(pDetails, 'pdde');
  // console.log(fullDetails, 'fulldetails');
  // console.log(sectionContent, 'sct');
  // console.log(isScheduled, 'schedule');
  const extractDescription = body => {
    // Check if body exists and is iterable (an array)
    if (!Array.isArray(body)) {
      return ''; // Return empty string if body is not present or is not an array
    }

    // Loop through the body array and find the structured text section
    for (let section of body) {
      // Check if this section has structured text
      if (section?.sectionContent?.[0]?.body?.value?.document?.children) {
        const children = section.sectionContent[0].body.value.document.children;

        // Loop through children to find the paragraph with content
        for (let child of children) {
          if (child.type === 'paragraph') {
            for (let paragraphChild of child.children) {
              if (paragraphChild.type === 'span') {
                return paragraphChild.value; // Extract the paragraph text
              }
            }
          }
        }
      }
    }
    return ''; // Return empty string if no description found
  };
  const nonScheduledDescription = extractDescription(fullDetails?.body) || '';

  // const nonScheduledDescription =
  //   fullDetails?.body?.[0]?.sectionContent?.[0]?.body?.value?.document
  //     ?.children?.[1]?.children?.[0]?.value || '';

  // Helper function to get day, month, year and time
  const formatDate = dateStr => {
    // console.log('formatDate', dateStr);
    if (!dateStr) {
      return {};
    }
    const date = new Date(dateStr);
    const day = format(date, 'd');
    const month = format(date, 'MMMM');
    const year = format(date, 'yyyy');
    const time = format(date, 'h:mm a'); // Format time as "5 PM" or "5 AM"
    return { day, month, year, time };
  };

  // Extract start and end details
  const {
    day: startDay,
    month: startMonth,
    year: startYear,
    time: startTime,
  } = formatDate(startDate);
  const { day: endDay, month: endMonth, year: endYear } = formatDate(finalDate);

  let displayDate = '';

  if (startDay && endDay) {
    // Check if start and end date are the same or different
    if (
      startDay === endDay &&
      startMonth === endMonth &&
      startYear === endYear
    ) {
      // Same start and end date
      displayDate = `${startDay} ${startMonth} ${startYear} | ${startTime}`;
    } else {
      // Different start and end dates
      displayDate = `${startDay} - ${endDay} ${startMonth} ${startYear} | ${startTime}`;
    }
  }
  // console.log(startDate, finalDate, 'dates');
  // console.log(isScheduled, 'schedule');
  const showSeparator = (index, length) => {
    // Check if we're at lg breakpoint and not at the last item
    return useBreakpointValue({ base: index < length - 1 });
  };
  const buttonData = sectionContent.find(
    item => item._modelApiKey === 'simple_button'
  );

  // function calculateHoursDifference(start, end) {
  //   const startDate = new Date(start);
  //   const endDate = new Date(end);

  //   // Calculate the time difference in milliseconds
  //   const timeDifference = endDate - startDate;

  //   // Convert milliseconds to hours and minutes
  //   const hoursDifference = timeDifference / (1000 * 60 * 60);
  //   const minutesDifference = timeDifference / (1000 * 60);

  //   // Return the time in hours if >= 1 hour, otherwise in minutes
  //   if (hoursDifference >= 1) {
  //     return `${Math.floor(hoursDifference)} hours`;
  //   } else {
  //     return `${Math.floor(minutesDifference)} minutes`;
  //   }
  // }

  const latLong = pDetails?.latlong?.split(',');
  const pageUrl = `${config.BASE_PATH}/project-samskriti/productions?id=${pDetails?.latlong}`;
  // console.log('latLong', pDetails);

  useEffect(() => {
    const handleScroll = () => {
      const fixedBtn = document.getElementById('fixedBtn');
      const mainCta = document.getElementById('mainCta');
      const targetSection = document.getElementById('ps-prod-upcoming-list');
  
      if (!fixedBtn || !mainCta || !targetSection) return;
  
      const mainCtaRect = mainCta.getBoundingClientRect();
      const targetRect = targetSection.getBoundingClientRect();
  
      const isMainCtaOutOfView = mainCtaRect.bottom <= 0;
      const isTargetSectionInView = targetRect.top < window.innerHeight && targetRect.bottom > 0;
      const hasUserScrolledPastTarget = targetRect.top < 0 && targetRect.bottom < 0;
  
      if (isTargetSectionInView || hasUserScrolledPastTarget) {
        fixedBtn.style.display = 'none';
      } else if (isMainCtaOutOfView) {
        fixedBtn.style.display = 'flex';
      } else {
        fixedBtn.style.display = 'none';
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {buttonData && (<Portal> <Box display={'none'}
        bottom={{ base: '0px', md: '50%' }}
        right={{ base: '0px', md: '0px' }}
        id='fixedBtn' position={'fixed'} zIndex={20} cursor={'pointer'} bgColor={{ base: '#fff', md: 'transparent' }}
        boxShadow={{
          base: `
      0px 0.54px 3.62px 0px #26212106,
      0px 2.36px 7.5px 0px #26212109,
      0px 5.8px 14.95px 0px #2621210B,
      0px 11.17px 29.3px 0px #2621210E,
      0px 18.8px 53.88px 0px #26212111,
      0px 29px 92px 0px #26212117
    `, md: 'none'
        }}
        width={{base:'100%', md:'auto'}} alignItems={'center'} height={'82px'}
        justifyContent={{ base: 'center', md: 'flex-end' }}
      >
        <Link
          paddingX={{ base: '', lg: '2.5rem' }}
          width={{ base: '296px', md: '224px' }}
          height={{ base: '50px', lg: '61px' }}
          py={{ base: '0.75rem', lg: '1rem' }}
          fontSize={{ base: '1rem', md: '1.125rem' }}
          lineHeight={{ base: '1.6rem', md: '1.8' }}
          letterSpacing={'0.32px'}
          fontFamily={'var(--FedraSansStd-medium)'}
          color={'#010509'}
          // mt={{lg:"1rem"}}
          bgColor={'#F18128'}
          textAlign="center"
          borderRadius={'none'}
          border={'none'}
          _hover={{
            bg: '#F2C251',
          }}
          href={refineUrlDomain(buttonData.linkUrl, region, lang)}
        >
          {buttonData.buttonText}
        </Link>
      </Box></Portal>)}

      <Box
        position={'relative'}
        bg={'#010509'}
        width="100%"
        // display="flex"
        pb={{
          base: '10rem',
          lg: '0',
          '2xl': '0',
        }}
        maxW={1320}
        mx="auto"
      >
        {/* mid wrapper */}
        <Box
          width={{ lg: '80%', xl: '100%' }}
          maxWidth="973px"
          position={'relative'}
          top={{ base: '10%', lg: '-14rem' }}
          mx="auto"
          sx={{
            clipPath: {
              base: 'polygon(0 0, 100% 0%, 100% 97%, 0% 100%)',
              lg: 'polygon(0 0, 100% 0%, 100% 95%, 0% 100%)',
            },
          }}
          zIndex={1}
        >
          {/* heading container */}
          <Box
            position={'relative'}
            width={{ base: '100%', lg: '100%' }}
            // top={{ base: '18%', md: '10vh', lg: '6.8rem' }}
            display="flex"
            px={{ base: '16px', md: '0' }}
            flexDirection="column"
            justifyContent="center"
            mx="auto"
          >
            <Box
              display={'flex'}
              width={{ lg: '100%' }}
              // border={'2px solid green'}
              gap={{ base: '1rem', lg: '4rem' }}
              flexDirection={{ base: 'column', lg: 'row' }}
              justifyContent={{ base: 'center' }}
              boxShadow="0px 0.54px 3.62px 0px #26212106, 0px 2.36px 7.5px 0px #26212109, 0px 5.8px 14.95px 0px #2621210B, 0px 11.17px 29.3px 0px #2621210E, 0px 18.8px 53.88px 0px #26212111, 0px 29px 92px 0px #26212117"
              alignItems={{ lg: 'center' }}
              textAlign={{ base: 'center', lg: 'left' }}
              bgColor={{ base: '#F1EDE9', lg: '#F1EDE9' }}
              py={{ base: '2rem', lg: '2rem' }}
              paddingX={{ lg: '3rem', base: '.5rem' }}
              paddingTop={{ lg: '40px', base: '1rem' }}
              // paddingBottom={{ lg: '2rem' }}
            >
              {/* text wrapper */}
              <Box
                // additional change
                width={{ lg: '100%' }}
                display="flex"
                flexDirection={{ base: 'column' }}
                gap={{ lg: '1rem' }}
              >
                {/* heading 1 */}
                <Box
                  letterSpacing={'0.32px'}
                  color={{ base: '#010509' }}
                  fontFamily={'var(--FedraSansStd-medium)'}
                  textAlign="left"
                  fontSize={{ base: '1.125rem', md: '1.25rem' }}
                  lineHeight={{ base: '1.8rem', md: '2rem' }}
                >
                  {pDetails?.title}
                </Box>
                {/* multiple words */}

                <Box
                  fontSize={{ base: '0.875rem', md: '1rem' }}
                  fontFamily={'var(--FedraSansStd-book)'}
                  letterSpacing={'0.32px'}
                  color={{ base: '#010509' }}
                  fontWeight={350}
                  alignItems={{ base: 'flex-start', md: 'flex-start' }}
                  gap={{ base: '0rem' }}
                  display={'flex'}
                  w="100%"
                  flexDir={{ base: 'column', lg: 'row' }}
                  lineHeight={{ base: '1.4rem', md: '1.6rem' }}
                  textAlign={{ base: 'left', md: 'center' }}
                >
                  {/* Collecting pieces of data to check for presence and render with separator */}
                  {[
                    pDetails?.language && (
                      <Box key="language" as="span">
                        {pDetails.language.charAt(0).toUpperCase() +
                          pDetails.language.slice(1)}
                      </Box>
                    ),
                    pDetails?.age && (
                      <Box key="age" as="span">
                        {pDetails.age}
                      </Box>
                    ),
                    pDetails?.popup_description && (
                      <Box key="time" as="span">
                        {/* {calculateHoursDifference(
                          pDetails.samskriti.startdate,
                          pDetails.samskriti.enddate
                        )} */}
                        {pDetails?.popup_description}
                      </Box>
                    ),
                  ]
                    // Filter out null values and map through the valid data
                    .filter(Boolean)
                    .map((item, index, array) => (
                      <Box key={index} display="flex" alignItems="center">
                        {item}
                        {/* Show separator based on index and length of valid data */}
                        {showSeparator(index, array.length) && (
                          <Box as="span" mx={{ base: '.5rem' }}>
                            {' '}
                            |{' '}
                          </Box>
                        )}
                      </Box>
                    ))}
                  <Box
                    mt={{base: '0px', md: '0px', lg:'0px', xl: '-40px'}}
                    gap={{ lg: '3rem', base: '1.8rem' }}
                    display="flex"
                    width={{ base: '100%', sm: 'auto' }}
                    // marginBottom={{ lg: '5rem' }}
                    // alignSelf={{ base: "flex-start", md: "flex-end" }}
                    ml={{ lg: 'auto' }}
                  >
                    {/* Button */}
                    {buttonData && (
                      <Link
                        id='mainCta'
                        paddingX={{ base: '', lg: '2.5rem' }}
                        width={{ base: '100%', sm: '296px', lg: '225px' }}
                        height={{ base: '50px', lg: '61px' }}
                        py={{ base: '0.75rem', lg: '1rem' }}
                        fontSize={{ base: '1rem', md: '1.125rem' }}
                        lineHeight={{ base: '1.6rem', md: '1.8' }}
                        letterSpacing={'0.32px'}
                        fontFamily={'var(--FedraSansStd-medium)'}
                        color={'#010509'}
                        // mt={{lg:"1rem"}}
                        bgColor={'#F18128'}
                        textAlign="center"
                        borderRadius={'none'}
                        border={'none'}
                        _hover={{
                          bg: '#F2C251', // Sets the background color on hover
                        }}
                        href={refineUrlDomain(buttonData.linkUrl, region, lang)}
                        prefetch
                        // onClick={() => (window.location.href = buttonData.linkUrl)}
                      >
                        {buttonData.buttonText}
                      </Link>
                    )}

                    {/* <Box
                //  as="span"
                display="Flex"
                alignItems={{ base: 'center' }}
                justifyContent={{ base: 'center' }}
                color="#9F4701"
                gap={{ base: '.5rem' }}
                fontFamily={"var(--FedraSansStd-medium)"}
                fontSize={{ base: '1rem' }}
                lineHeight={{ base: '1.8rem', md: '2rem' }}
              >
                <FaPlus />
                <Text cursor="pointer">Add to Calendar</Text>
              </Box> */}
                  </Box>
                </Box>

                {isScheduled && (
                  <Box
                    // mt={{ base: '1rem', lg: '0' }}
                    // top={{ lg: '45%' }}
                    my="1rem"
                    // // position={'absolute'}
                    // py={{ lg: '2rem' }}
                  >
                    <Divider
                      borderColor="#000000"
                      borderWidth="1px"
                      opacity="20%"
                      width="100%"
                    />
                  </Box>
                )}
                <Box
                  color={{ base: '#000000' }}
                  display="flex"
                  flexDirection={{ base: 'column', lg: 'row' }}
                  // as="block"
                  fontSize={{ base: '0.875rem', md: '1rem' }}
                  fontFamily={'var(--FedraSansStd-book)'}
                  letterSpacing={'0.32px'}
                  gap={{ base: '.5rem' }}
                  // whiteSpace={"nowrap"}
                  // border={'2px solid green'}
                  mt={{ base: '1rem', lg: '1.5rem' }}
                  alignItems={{ base: 'flex-start', lg: 'flex-start' }}
                  fontWeight={350}
                  lineHeight={{ base: '1.4rem', md: '1.6rem' }}
                >
                  {displayDate && (
                    <Box
                      display={{ base: 'flex' }}
                      gap={{ base: '.5rem' }}
                      alignItems={{ base: 'center' }}
                      width={{ lg: '30%' }}
                    >
                      <Box
                        display={{ lg: 'none' }}
                        width="18px"
                        height="18px"
                        fontSize={{ base: '18px' }}
                      >
                        <FiClock color="#9F4701" width="100%" height="100%" />
                      </Box>
                      {/* {pDetails?.date} */}
                      {displayDate}
                    </Box>
                  )}

                  {(pDetails?.address || pDetails?.city) && (
                    <Box
                      width={{ base: '100%', lg: '70%' }}
                      display={{ base: 'flex' }}
                      gap={{ base: '.5rem' }}
                      fontWeight="500"
                      textAlign="left"
                      alignItems={{ base: 'flex-start' }}
                    >
                      <Box
                        display={{ lg: 'none' }}
                        width="14px"
                        height="18px"
                        mt="5px"
                      >
                        <IoLocationOutline
                          color="#9F4701"
                          fontSize="1.2rem"
                          width="100%"
                          height="100%"
                        />
                      </Box>
                      {pDetails?.address},{pDetails?.city}
                    </Box>
                  )}

                  {pDetails?.amount?.[0]?.amount && (
                    <Box
                      as="span"
                      width={{ base: '100%', md: '25%' }}
                      fontWeight={{ lg: '500', base: '400' }}
                      gap={{ base: '.5rem' }}
                      display={{ base: 'flex' }}
                      alignItems={{ base: 'flex-start' }}
                      fontFamily={{
                        lg: 'var(--FedraSansStd-medium)',
                        base: 'var(--FedraSansStd-book)',
                      }}
                    >
                      <Box
                        display={{ lg: 'none' }}
                        width="12.2px"
                        height="18px"
                        mt="5px"
                      >
                        <PiCurrencyInrBold
                          color="#9F4701"
                          width="100%"
                          height="100%"
                        />
                      </Box>
                      <Box>
                        {pDetails?.currency} {pDetails?.amount?.[0]?.amount}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* all text container */}
          <Box
            py={{ lg: '12rem', base: '12rem', md: '12rem' }}
            // pb="5rem"
            px={{ base: '1rem', md: '5rem', lg: '7.5rem' }}
            bgColor={{ base: '#F1EDE9' }}
            w="100%"
            mt="-8rem"
          >
            <Box
              display={{ base: 'block', lg: 'none' }}
              // width={{ base: '3rem', md: '5.313rem', lg: '8.056875rem' }}
              // height={{ base: '10rem', md: '25rem', lg: '49.6875rem' }}
              // position="absolute"
              // top={{ base: '-1rem', md: '-10rem', lg: '0' }}
              // zIndex="20"
              // left={{ base: '3.5rem', md: '10rem', lg: '2.5rem' }}
              // left={{ '2xl': '18%', base: '3.5rem', md: '10rem', lg: '5%', xl: '5%' }}
            >
              <Icon
                width="236px"
                height="42px"
                viewBox="0 0 236px 42px"
                fill="none"
              >
                <path
                  d="M165.455 41.8899C165.628 40.9923 165.81 40.0952 165.97 39.1953C166.042 38.7926 166.339 37.0077 166.4 36.9628C166.461 36.9179 168.416 36.9271 168.441 36.9441C168.466 36.9611 168.155 39.6135 168.121 40.5667C168.29 40.6853 168.46 40.804 168.629 40.9227C168.695 40.6998 169.723 36.7646 169.751 36.7323C169.78 36.7 173.887 36.4607 175.459 36.2959C177.285 36.1035 179.096 35.7728 180.919 35.5362C184.673 35.0483 188.424 34.5408 192.185 34.1186C196.338 33.6519 200.435 34.2857 204.487 35.1556C208.671 36.0526 212.835 37.0652 216.982 38.137C219.647 38.8253 224.667 39.5512 228.563 38.6602C232.46 37.7693 235.312 33.894 235.351 30.5448C235.37 28.9169 235.209 27.2687 234.954 25.6587C234.417 22.2733 232.766 14.3758 232.512 13.8281C232.436 13.6624 232.223 13.5947 232.04 13.4806C231.878 13.6287 231.736 13.8272 231.696 14.0583C231.536 14.9529 231.694 15.8122 231.535 16.7845C231.148 19.1495 230.314 21.1082 229.236 23.1072C228.249 24.9391 226.904 26.6509 227.01 28.962C227.052 29.8673 227.442 30.3275 228.229 30.7719C228.991 31.201 229.933 31.2605 230.765 31.0998C231.597 30.9391 232.173 30.3471 232.532 29.4208C232.95 28.3436 233.041 27.3312 232.594 26.2544C232.512 26.0513 232.364 25.8136 232.224 25.8144C232.085 25.8153 231.885 26.0658 231.822 26.2589C231.565 27.0327 231.616 28.3584 231.098 28.9742C230.364 29.8415 229.338 29.5312 228.832 29.0694C228.327 28.6076 228.409 26.9702 229.086 25.7739C229.903 24.3314 231.168 22.8295 232.283 21.4091C232.283 21.4091 232.569 22.1541 232.616 22.2639C233.718 24.7868 234.731 27.288 234.542 30.1947C234.331 33.4322 232.274 35.7707 229.657 36.8719C226.763 38.0898 223.655 37.8528 220.699 37.4745C216.872 36.9851 213.068 36.0591 209.338 34.997C204.939 33.7446 200.505 32.87 195.968 32.7603C193.149 32.6915 190.309 32.8441 187.505 33.1395C184.28 33.4798 181.087 34.1249 177.871 34.5679C175.494 34.8946 173.102 35.113 170.714 35.3651C170.597 35.3776 169.868 35.4582 169.837 35.4409C169.805 35.4236 170.016 32.4191 170.06 32.3769C170.104 32.3348 170.975 32.3752 171.151 32.3724C173.262 32.3304 184.071 31.6565 187.563 29.5953C190.699 27.7424 192.379 24.5155 191.619 19.6556C191.236 17.2088 190.504 14.8011 189.733 12.4429C189.196 10.7992 189.025 9.13994 188.86 7.45453C188.831 7.14089 188.668 6.8425 188.567 6.53626C188.367 6.7868 188.091 7.00567 187.983 7.29383C187.22 9.3421 187.054 11.8351 185.53 14.3737C183.868 17.1426 182.513 20.2693 182.433 21.7056C182.352 23.1437 182.71 24.2677 183.624 25.053C184.52 25.8216 185.93 25.683 186.435 25.4867C187.556 25.0512 188.232 23.8319 188.518 22.7259C188.804 21.6198 188.577 20.1381 187.973 19.4248C187.761 19.1737 187.221 18.9573 186.923 19.1065C186.644 19.2458 186.537 19.7193 186.565 20.0328C186.664 21.1154 186.743 22.5888 186.425 23.2364C186.108 23.884 184.993 24.1874 184.558 23.2858C184.123 22.3842 184.184 20.6699 184.75 19.4864C185.301 18.3339 187.835 14.4479 187.892 14.4575C187.95 14.4671 190.238 18.4191 190.332 21.116C190.426 23.8129 189.867 25.6709 188.698 26.9265C187.529 28.1821 186.199 28.8995 184.787 29.479C182.944 30.2371 176.694 31.0094 175.57 31.1059C174.11 31.2298 172.64 31.2793 171.173 31.3076C170.756 31.3156 170.124 31.3139 170.094 31.2561C170.063 31.1983 170.072 30.6111 170.1 30.1324C170.144 29.372 170.28 28.6193 170.373 27.8629C170.406 27.6015 170.503 27.3217 170.449 27.0793C170.336 26.5749 170.142 26.0898 169.983 25.5958C169.73 25.9762 169.44 26.3374 169.231 26.7446C168.873 27.4451 168.542 28.1503 169.041 28.9719C169.171 29.1841 168.934 31.247 168.89 31.2927C168.846 31.3383 166.674 31.1536 166.647 31.1083C166.619 31.063 166.615 30.4857 166.615 30.3252C166.62 29.4202 166.785 28.5188 166.826 27.6136C166.852 27.0395 166.795 26.4546 166.718 25.883C166.697 25.7215 166.464 25.4606 166.35 25.4714C166.168 25.4898 165.922 25.6553 165.846 25.8284C165.696 26.1641 165.577 26.5452 165.564 26.9117C165.528 27.9088 165.561 28.909 165.552 29.9074C165.552 30.4192 165.538 31.0608 165.485 31.129C165.431 31.1972 164.875 31.1496 164.365 31.0952C161.187 30.7581 158 30.4701 154.843 29.9787C152.164 29.5615 149.532 28.8305 146.861 28.3448C143.185 27.675 139.494 27.0787 135.802 26.5036C133.032 26.0717 130.256 25.6449 127.471 25.3641C125.336 25.1493 123.181 25.11 121.034 25.0905C118.999 25.0707 116.956 25.0823 114.93 25.2499C111.638 25.5219 108.355 25.9178 105.072 26.2872C101.309 26.7112 97.5497 27.1635 93.7894 27.6017C93.4889 27.636 90.3608 27.8959 87.9491 27.2876C86.0901 26.8186 84.8097 25.4841 84.6442 25.3109C84.2146 24.863 83.6477 24.1214 83.6579 24.0742C83.6619 24.055 85.0426 23.0629 85.8347 22.2634C87.0556 21.0295 87.9551 19.6543 88.6526 18.3636C90.2389 15.4255 90.6107 12.1616 90.395 9.91986C90.2473 8.39224 89.8675 6.88606 89.5566 5.16767C89.2663 5.43886 88.8788 5.62105 88.8043 5.89831C88.2194 8.03393 86.6114 9.39357 85.3671 11.0429C84.8672 11.7053 83.9499 13.2474 83.813 14.6495C83.6822 15.9777 84.1089 17.0748 84.6322 17.3257C85.4547 17.7204 86.437 17.1676 86.9374 16.4911C87.4378 15.8145 87.6806 14.6836 87.9408 13.8253C87.987 13.6756 87.7937 13.2805 87.7937 13.2805C87.7937 13.2805 87.4012 13.3654 87.2981 13.4914C87.1238 13.7043 86.8905 14.428 86.53 14.8072C86.2155 15.1373 85.8437 15.262 85.5816 15.1727C85.3195 15.0834 85.1032 14.7121 85.0719 14.2572C85.0317 13.6696 85.4228 12.9564 85.6003 12.7014C86.5236 11.3713 87.5912 10.1465 88.686 8.77637C88.8265 8.84261 89.2184 9.67702 89.3221 10.4386C89.5281 11.953 89.3206 14.0454 88.8422 15.2964C88.178 17.0367 86.7811 19.5757 85.2286 21.1901C84.3243 22.131 83.0457 22.886 83.0255 22.878C82.9616 22.8575 82.7141 21.9325 82.637 21.3785C82.453 20.0575 82.385 18.6781 82.5309 17.3576C82.6115 16.6236 82.954 13.849 82.525 11.5325C82.0603 9.02553 80.8136 6.98676 80.7315 6.81018C80.2021 5.68204 79.0931 3.6935 78.443 2.04297C78.0189 0.967149 77.916 -0.0555785 77.8717 -0.288711C77.7557 -0.279745 77.4828 0.02928 77.4631 0.151928C77.2221 1.7064 76.1158 4.29883 75.2926 6.30035C74.6426 7.87901 74.2198 9.0972 74.1923 9.1048C74.1305 9.12146 73.5906 8.95455 73.0735 8.76923C70.9326 8.00535 68.805 7.20324 66.6679 6.42894C66.5 6.36854 66.3035 6.39511 66.1204 6.37991C66.1075 6.59815 66.105 6.85567 66.1892 7.02175C66.3958 7.42619 66.3659 9.40296 66.5957 11.1089C66.7984 12.6196 67.2329 14.2147 67.2293 14.218C67.2258 14.2214 65.6272 14.985 65.2174 15.175C63.4794 15.9837 60.669 16.157 59.6664 15.7066C59.5677 15.6617 59.445 15.6686 59.3329 15.6671C59.2819 15.6666 59.2311 15.7067 59.1274 15.7533C59.3191 16.48 59.7119 16.9544 60.4577 17.1199C61.0364 17.248 62.5373 17.3129 63.9899 16.9733C65.7133 16.5699 67.465 15.7107 67.4918 15.7243C67.5185 15.7378 68.9963 18.7309 70.3094 19.3416C71.1826 19.7474 72.009 19.9394 72.9637 19.2089C73.6979 18.6486 74.058 17.4735 73.7579 16.6397C73.2225 15.1583 72.1912 14.4667 70.6479 14.2534C69.7036 14.1233 68.613 14.0907 68.5303 14.027C68.4475 13.9633 67.8362 11.944 67.7201 11.1006C67.5878 10.1401 67.6246 8.49364 67.6771 8.45186C67.7296 8.41008 68.3155 8.57375 68.6557 8.6665C70.2137 9.08686 71.7673 9.53526 73.3017 10.0428C73.4127 10.0795 73.8499 10.2171 73.8767 10.2766C73.9034 10.336 73.6499 12.2905 73.8887 13.9333C74.0619 15.1286 75.5667 17.0359 76.7228 16.9496C78.0323 16.8525 79.1393 15.5218 79.1546 14.049C79.1645 13.1072 78.4298 11.6346 77.3074 10.6372C76.6151 10.0224 75.3182 9.57831 75.3182 9.57831C75.3182 9.57831 75.4373 9.10187 75.5319 8.83433C75.9179 7.73979 76.5779 5.78749 77.1027 4.56854C77.3568 3.97987 77.6528 3.59423 77.7293 3.50233C77.9337 4.15725 78.479 5.6002 78.8085 6.27655C79.0715 6.81585 80.5933 9.19858 81.1055 11.8047C81.616 14.4107 81.1168 17.2418 81.0547 17.9784C81.0072 18.5445 81.0162 19.8137 81.1744 20.9535C81.3449 22.1787 81.6667 23.2605 81.6504 23.2898C81.634 23.3191 79.5017 24.0255 77.2602 23.7936C75.0898 23.5701 72.8184 22.4122 72.152 22.1709C69.4005 21.1716 66.6015 20.5973 63.6598 20.9219C62.6355 21.0352 61.5768 20.7764 60.5332 20.7618C60.2017 20.7577 59.8668 20.9916 59.5341 21.118C59.6967 21.5152 59.7598 22.1303 60.0421 22.2734C61.2498 22.8829 61.9331 23.9826 62.791 24.9595C64.1538 26.5111 65.6558 27.9242 67.6996 28.5497C69.1731 29.0016 70.6929 28.7797 71.6831 27.862C72.6716 26.9442 72.5138 25.4143 72.1436 24.9726C71.7733 24.5309 70.9079 23.7178 70.1373 23.9642C69.8655 24.0509 69.5032 24.5748 69.5096 24.6351C69.5159 24.6953 70.8451 25.8078 70.8805 26.1958C70.9365 26.8177 70.3717 27.1085 69.7858 27.183C68.2228 27.3783 66.8572 26.8571 65.7295 25.7694C64.8172 24.8889 64.0076 23.893 63.173 22.9313C63.0358 22.7735 62.5135 22.1627 62.5135 22.1627C62.5135 22.1627 63.5076 21.898 65.5042 21.9426C67.4617 21.9854 70.5936 23.141 73.2362 24.4265C74.0318 24.813 75.8999 25.406 77.6837 25.5046C79.6558 25.6134 82.413 24.8359 82.4582 24.8556C82.48 24.8654 82.8372 25.4812 83.4941 26.0856C84.528 27.0368 86.1881 28.1675 87.5688 28.4583C90.6829 29.1119 94.5289 28.7039 95.0312 28.638C98.8925 28.132 102.75 27.5992 106.615 27.1269C108.437 26.9043 110.272 26.7282 112.106 26.6544C115.544 26.5142 118.987 26.3619 122.425 26.4052C125.352 26.4417 128.287 26.6427 131.203 26.9575C134.465 27.3089 137.709 27.8553 140.957 28.3454C143.556 28.7362 156.339 31.1798 160.194 31.6069C161.71 31.7748 163.223 31.9779 164.741 32.1318C164.96 32.1539 165.405 32.1613 165.44 32.1823C165.475 32.2032 165.462 32.6226 165.458 32.9048C165.456 32.9629 165.456 33.0229 165.456 33.0811C165.453 34.4239 165.317 35.5824 165.288 35.6182C165.26 35.654 164.036 35.7337 162.938 35.752C160.001 35.8016 157.06 35.7926 154.125 35.6429C151.078 35.4881 147.683 35.3126 144.637 35.0978C143.217 34.9977 139.819 34.8521 136.753 34.4388C134.04 34.073 131.615 33.4412 130.626 33.2473C128.457 32.8245 126.304 32.2524 124.12 32.0036C121.904 31.7517 117.227 31.1945 113.194 31.04C109.91 30.9136 107.068 31.1561 106.196 31.2268C102.903 31.4969 99.6112 31.813 96.325 32.1647C93.7388 32.4415 91.1627 32.8141 88.5788 33.1193C85.831 33.4436 83.0788 33.7484 80.3286 34.0462C79.166 34.1728 75.6949 34.6538 71.7883 34.9038C66.8301 35.2217 61.1658 35.3089 58.5889 35.3709C54.5586 35.4671 50.6794 34.4266 46.8069 33.3917C44.1471 32.6806 41.4779 31.9974 38.7998 31.372C38.0577 31.1979 32.7505 30.0039 27.3326 29.8109C23.3567 29.6696 19.0447 30.4609 17.8235 30.6096C15.5843 30.8824 13.369 31.3434 11.1419 31.7067C7.99618 32.2199 4.83055 32.1022 1.66265 32.0003C0.939056 31.977 0.210533 32.0911 -0.515783 32.1435C-0.520636 32.2792 -0.527103 32.413 -0.533663 32.5486C-0.215789 32.6474 0.0994863 32.8184 0.420385 32.8327C3.19298 32.9559 5.97129 33.2046 8.73661 33.1033C10.8651 33.0249 12.9748 32.4746 15.0977 32.1736C16.0377 32.0407 18.2467 31.613 20.4484 31.3914C22.4435 31.1889 24.4335 31.1802 25.4707 31.2316C28.5874 31.3877 31.8968 32.0482 32.8569 32.2109C34.8532 32.5483 41.4976 34.204 42.8545 34.4919C44.1524 34.7666 52.875 36.5622 55.9619 36.7417C59.5001 36.9483 63.0666 37.0803 66.6212 36.64C69.2226 36.3179 71.8528 36.2389 74.4658 36.0232C76.2379 35.8761 78.0054 35.6705 79.7747 35.5074C81.288 35.3681 82.8052 35.2644 84.3187 35.1234C86.7074 34.9013 89.0964 34.6704 91.4841 34.4288C93.6193 34.2131 95.7544 33.9974 97.8857 33.7462C99.9588 33.5031 105.138 32.9161 107.409 32.7823C109.681 32.6486 114.742 32.6758 116.94 32.747C119.172 32.8196 121.412 32.9068 123.631 33.1659C126.267 33.4736 128.888 33.9623 131.513 34.386C133.825 34.7587 136.125 35.2368 138.449 35.497C139.911 35.6608 143.329 35.8479 146.222 36.0946C149.112 36.343 163.673 36.9052 164.137 36.9046C164.601 36.9041 165.125 36.8973 165.153 36.9356C165.18 36.9739 165.152 37.5638 165.133 37.9476C165.089 38.9162 165.045 39.8848 165.04 40.8533C165.038 41.199 165.146 41.5462 165.205 41.8911C165.29 41.8878 165.375 41.8863 165.46 41.8831L165.455 41.8899ZM77.2556 15.4593C76.987 15.5991 76.4318 15.4332 76.2125 15.1941C75.643 14.5706 75.2372 13.6491 75.0671 12.5564C74.9581 11.8492 74.9827 10.7316 75.0054 10.7149C75.0229 10.7016 75.8748 11.1788 76.2248 11.4749C76.6655 11.8474 77.5508 12.7214 77.8145 13.7654C78.026 14.6024 77.6907 15.2298 77.254 15.4574L77.2556 15.4593ZM72.5443 17.7627C72.4489 18.339 71.904 18.4542 71.3194 18.3012C70.61 18.1179 70.0232 17.2166 69.7227 16.8239C69.4238 16.4312 68.9859 15.6954 69.0075 15.6628C69.029 15.6302 70.3983 15.6699 70.9816 15.8599C71.9531 16.1783 72.6725 16.9849 72.5443 17.7627ZM166.592 32.4028C166.603 32.3927 168.721 32.4127 168.762 32.4481C168.803 32.4834 168.642 35.5096 168.608 35.5504C168.575 35.5913 166.531 35.594 166.499 35.5591C166.468 35.5242 166.58 32.4129 166.592 32.4011L166.592 32.4028Z"
                  fill="#010509"
                />
              </Icon>
            </Box>

            {/* box1 container */}
            {pDetails?.description && (
              <Box mt={{ base: '1rem', md: '0' }}>
                {/* box for heading */}
                <Box
                  lineHeight={{ base: '1.8rem', md: '2.7rem' }}
                  letterSpacing={'0.16px'}
                  color="#010509"
                  marginTop={{ lg: '1.5rem' }}
                  // fontWeight={400}
                  fontFamily="var(--FedraSerifDisplay-Regular)"
                  fontSize={{ md: '2.25rem', base: '1.5rem' }}
                >
                  Synopsis
                </Box>
                {/* box for paragraph */}
                <Box
                  lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                  letterSpacing={'0.32px'}
                  color={{ base: '#0E1216', lg: '#010509' }}
                  fontWeight={400}
                  marginTop={{ lg: '2rem', base: '1.5rem' }}
                  fontFamily={'var(--FedraSansStd-book)'}
                  fontSize={{ md: '1.125rem', base: '0.875rem' }}
                  w="100%"
                  className="perfText"
                >
                  {/* {parser(pDetails?.description)} */}
                  {parser(
                    isScheduled
                      ? pDetails?.description
                      : nonScheduledDescription
                  )}
                </Box>
                <style>
                  {`
                .perfText h3 {                  
                  font-family: var(--FedraSansStd-medium);
                }
                .perfText ul {
                  margin-left: 30px;
                }
              `}
                </style>
              </Box>
            )}
            {/*  box1 ends here */}
            {/* box2  */}
            <Box
              // border="2px solid black"
              marginTop={{ base: '1.5rem', lg: '2rem' }}
              display="flex"
              justifyContent={{ lg: 'space-between' }}
              flexDirection={{ base: 'Column', lg: 'row' }}
            >
              {/* left box */}
              {/* <Box marginTop={{ lg: '2rem' }} border={'2px solid violet'}> */}
              {/* heading */}
              {/* <Box
              lineHeight={{ base: '1.8rem', md: '2.7rem' }}
              letterSpacing={'0.16px'}
              fontWeight={400}
              fontFamily="var(--FedraSerifDisplay-Regular)"
              fontSize={{ md: '2.25rem', base: '1.5rem' }}
            >
              Details{' '}
            </Box>
            {/* box for multiple lines */}
              {/* <Box
              display="flex"
              flexDirection="column"
              gap={{ md: '1.5rem', base: '1rem' }}
              mt={{ lg: '2rem', base: '1.5rem' }}
            >
              <Box display="flex" alignItems="center" gap={{ base: '.5rem' }}>
                <Text
                  lineHeight={{ md: '2rem', base: '1.6rem' }}
                  letterSpacing={'0.32px'}
                  fontFamily={"var(--FedraSansStd-medium)"}
                  fontSize={{ md: '1.25rem', base: '1rem' }}
                >
                  Fees:
                </Text>
                <Text
                  lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                  letterSpacing={'0.32px'}
                  fontWeight={400}
                  fontFamily={"var(--FedraSansStd-book)"}
                  fontSize={{ md: '1.125rem', base: '0.875rem' }}
                >
                  {pDetails?.currency} {pDetails?.amount?.[0]?.amountt}
                </Text>
              </Box>
              <Box display="flex" alignItems="center" gap={{ base: '.5rem' }}>
                <Text
                  lineHeight={{ md: '2rem', base: '1.6rem' }}
                  letterSpacing={'0.32px'}
                  fontFamily={"var(--FedraSansStd-medium)"}
                  fontSize={{ md: '1.25rem', base: '1rem' }}
                >
                  Date & Time:
                </Text>
                <Text
                  lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                  letterSpacing={'0.32px'}
                  fontWeight={400}
                  fontFamily={"var(--FedraSansStd-book)"}
                  fontSize={{ md: '1.125rem', base: '0.875rem' }}
                  ml="5px"
                >
                  {pDetails?.date}
                </Text>
              </Box>{' '}
              <Box display="flex" alignItems="center" gap={{ base: '.5rem' }}>
                <Text
                  lineHeight={{ md: '2rem', base: '1.6rem' }}
                  letterSpacing={'0.32px'}
                  fontFamily={"var(--FedraSansStd-medium)"}
                  fontSize={{ md: '1.25rem', base: '1rem' }}
                >
                  Location:
                </Text>
                <Text
                  lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                  letterSpacing={'0.32px'}
                  width={{ lg: '70%' }}
                  fontWeight={400}
                  fontFamily={"var(--FedraSansStd-book)"}
                  fontSize={{ md: '1.125rem', base: '0.875rem' }}
                  ml="5px"
                >
                  {pDetails?.address}, {pDetails?.city}
                </Text>
              </Box> */}
              {/* </Box> */}
              {/* <Button
                borderRadius="none"
                border="none"
                mt={{ base: '1.5rem' }}
                bg="#C659271A"
                gap={{ base: '.5rem' }}
                width={{ base: '100%', lg: '232px' }}
                py={{ base: '0.75rem' }}
                // width={{ base: '328px', lg: '232px' }}
                paddingLeft={{ base: '1rem' }}
                paddingRight="1.5rem"
                display="flex"
                // justifyContent={{ base: 'center' }}
                color="#9F4701"
                lineHeight={{ base: '1.6rem' }}
                letterSpacing={'0.32px'}
                fontFamily={"var(--FedraSansStd-medium)"}
                fontSize={{ base: '1rem' }}
              >
                <FaPlus />
                Add to Calender
              </Button> */}
              {/* </Box> */}

              {isScheduled ? (
                <Box>
                  {/* heading */}
                  <Box
                    lineHeight={{ base: '1.8rem', md: '2.7rem' }}
                    letterSpacing={'0.16px'}
                    fontWeight={400}
                    color="#010509"
                    fontFamily="var(--FedraSerifDisplay-Regular)"
                    fontSize={{ md: '2.25rem', base: '1.5rem' }}
                  >
                    Details
                  </Box>
                  {/* box for multiple lines */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={{ md: '1.5rem', base: '1rem' }}
                    mt={{ lg: '2rem', base: '1.5rem' }}
                  >
                    {pDetails?.currency && pDetails?.amount?.[0]?.amount && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Fees:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontWeight={400}
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                        >
                          {pDetails?.currency} {pDetails?.amount?.[0]?.amount}
                        </Text>
                      </Box>
                    )}
                    {displayDate && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Date & Time:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          letterSpacing={'0.32px'}
                          fontWeight={400}
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                          ml="5px"
                          color="#0E1216"
                        >
                          {/* {pDetails?.date} */}
                          {displayDate}
                        </Text>
                      </Box>
                    )}
                    {pDetails?.address && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Location:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          width={{ lg: '70%' }}
                          fontWeight={400}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                          ml="5px"
                        >
                          {pDetails?.address}, {pDetails?.city}
                        </Text>
                      </Box>
                    )}
                    {pDetails?.duration && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Duration:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          width={{ lg: '70%' }}
                          fontWeight={400}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                          ml="5px"
                        >
                          {/* {pDetails} */}
                        </Text>
                      </Box>
                    )}
                    {pDetails?.language && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Medium:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          width={{ lg: '70%' }}
                          fontWeight={400}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                          ml="5px"
                          textTransform="capitalize"
                        >
                          {pDetails?.language}
                        </Text>
                      </Box>
                    )}

                    {pDetails?.prerequisites && (
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: '.5rem' }}
                      >
                        <Text
                          lineHeight={{ md: '2rem', base: '1.6rem' }}
                          letterSpacing={'0.32px'}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-medium)'}
                          fontSize={{ md: '1.25rem', base: '1rem' }}
                        >
                          Prerequisites:
                        </Text>
                        <Text
                          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
                          width={{ lg: '70%' }}
                          fontWeight={400}
                          color="#0E1216"
                          fontFamily={'var(--FedraSansStd-book)'}
                          fontSize={{
                            lg: '1.25rem',
                            md: '1.125rem',
                            base: '1rem',
                          }}
                          ml="5px"
                        >
                          {pDetails?.prerequisites}
                        </Text>
                      </Box>
                    )}
                  </Box>
                  {/* Add to Calendar button */}
                  {/* <Button leftIcon={<FaPlus />} borderRadius="none"
                  border="none"
                  mt={{ base: '1.5rem' }}
                  bg="rgba(198, 89, 39, 0.1)"
                  gap={{ base: '.5rem' }}
                  width={{ base: '100%', lgmd: '232px' }}
                  py={{ base: '0.75rem' }}
                  // width={{ base: '328px', lg: '232px' }}
                  paddingLeft={{ base: '1rem' }}
                  paddingRight="1.5rem"
                  display="flex"
                  // justifyContent={{ base: 'center' }}
                  color="#9F4701"
                  lineHeight={{ base: '1.6rem' }}
                  letterSpacing={'0.32px'}
                  fontFamily={"var(--FedraSansStd-medium)"}
                  fontSize={{ base: '1rem' }}
                  _hover={{ background: '#C659271A', color: '#9F4701' }}
                >
                  Add to Calender
                </Button> */}
                </Box>
              ) : (
                <Box>
                  {/* Placeholder for other content */}

                  {/* white box */}
                  {/* <Box
                    bg={'#FEFAF6'}
                    maxWidth={{ lg: '219px' }}
                    display={'flex'}
                    width={'100%'}
                    flexDirection={'column'}
                    gap={'1rem'}
                    paddingTop={'1rem'}
                  >
                    <Text
                      lineHeight={{ base: '1.8rem' }}
                      letterSpacing={'0.32px'}
                      color={'#010509'}
                      fontFamily={'var(--FedraSansStd-medium)'}
                      fontSize={{ base: '1.125rem' }}
                      ml={'1rem'}
                    >
                      {pDetails?.Schedule_Title}
                    </Text>
                    <Text
                      lineHeight={{ base: '1.6rem' }}
                      color={'#010509'}
                      letterSpacing={'0.32px'}
                      ml={'1rem'}
                      fontWeight={400}
                      fontSize={{ base: '1rem' }}
                    > 
                      {pDetails?.Schedule_description}
                    </Text>
                    <SimpleButton
                      paddingX={{ base: '2rem', lg: '2rem' }}
                      width={{ lg: '219px' }}
                      height={{ lg: '50px' }}
                      py={{ base: '0.75rem', lg: '1rem' }}
                      fontSize={{ base: '1rem', md: '1.125rem' }}
                      lineHeight={{ base: '1.6rem', md: '1.8' }}
                      letterSpacing={'0.32px'}
                      fontFamily={'var(--FedraSansStd-medium)'}
                      color={'#010509'}
                      // mt={{lg:"1rem"}}
                      bgColor={'#F18128'}
                      borderRadius={'none'}
                      border={'none'}
                      _hover={{
                        bg: '#F2C251', // Sets the background color on hover
                      }}
                      style={{
                        buttonText: pDetails.Schedule_button,
                        linkUrl: pDetails.program_url,
                        buttonStyle: 'Orange',
                      }}
                    ></SimpleButton>
                  </Box> */}
                </Box>
              )}
              {/* left box ends here */}
              {/* right box */}
              {isScheduled && (
                <Box>
                  {/* white box */}

                  <Box
                    marginTop={{ base: '1.5rem', lg: '0' }}
                    bgColor="#FEFAF6"
                    paddingTop={{ lg: '1rem' }}
                    width={{ lg: '219px' }}
                    // paddingX={{base:"1rem"}}
                  >
                    {/* box for texts */}
                    <Box paddingLeft={{ lg: '1rem' }}>
                      <Text
                        color={'#010509'}
                        textTransform={'uppercase'}
                        fontFamily={'var(--FedraSansStd-medium)'}
                        fontSize={{ base: '1.125rem' }}
                        lineHeight={{ md: '1.8rem' }}
                        letterSpacing={'0.32px'}
                        pt={{ base: '16px', md: '8px' }}
                      >
                        Venue
                      </Text>
                      <Text
                        color={'#010509'}
                        fontFamily={'var(--FedraSansStd-book)'}
                        fontWeight={400}
                        fontSize={{ md: '1rem', base: '0.875rem' }}
                        lineHeight={{ md: '1.6rem', base: '1.4rem' }}
                        letterSpacing={'0.32px'}
                      >
                        {pDetails?.address}, {pDetails?.city},{' '}
                        {pDetails?.country}
                      </Text>
                    </Box>

                    {/* box for map image */}
                    {/* {latLong[0]}dd */}
                    {latLong && (
                      <Box
                        mt={{ lg: '.5rem' }}
                        // border="2px solid green"
                        // backgroundImage="url('https://raw.githubusercontent.com/Pulkit2099/analogclock.github.io/main/map.png')"
                        // backgroundSize="cover"
                        // backgroundPosition="center"
                        // paddingX={{base:"1rem",lg:"0"}}
                        mx={{ base: '1rem', lg: '0' }}
                        height="143px"
                        position="relative" // Add relative positioning to the Box to position the icon inside it
                      >
                        <GoogleMap
                          sectionContent={{
                            url: `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d20000!2d${latLong[1]}!3d${latLong[0]}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1486486434098`,
                          }}
                          ht="180px"
                        />
                        <Link
                          target="_blank"
                          href={`https://maps.google.com/maps?ll=${latLong[0]}.${latLong[1]}&z=14&t=m&hl=en-US&gl=US&mapclient=embed`}
                        >
                          <LazyLoadImageComponent
                            src="https://raw.githubusercontent.com/Pulkit2099/analogclock.github.io/main/Icon-button.png"
                            alt="Icon Button"
                            position="absolute"
                            right="10px"
                            // top="50%"
                            bottom={0}
                            transform="translateY(-50%)" // Center vertically
                          />
                        </Link>
                      </Box>
                    )}
                  </Box>

                  {/* new box comes here */}

                  <Box
                    mt={{ base: '1rem', lg: '2.5rem' }}
                    display="flex"
                    flexDirection={{ base: 'column' }}
                    gap={{ base: '1.5rem' }}
                  >
                    <Text
                      fontSize={{ md: '1.125rem' }}
                      letterSpacing="0.32px"
                      display="flex"
                      justifyContent="center"
                      fontFamily={'var(--FedraSansStd-medium)'}
                      lineHeight={{ base: '1.8rem' }}
                      textTransform="uppercase"
                    >
                      Share this event
                    </Text>

                    {/* box for icon */}
                    <Box
                      display="flex"
                      flexWrap={{ lg: 'wrap' }}
                      maxWidth={{ lg: '187px' }}
                      justifyContent="center"
                      alignItems="center"
                      gap={{ base: '1.5rem', md: '2rem', lg: '1.8rem' }}
                      marginX={{ base: 'auto', lg: 'auto' }}
                    >
                      <WhatsappShareButton
                        url={config.imgPath}
                        title={''}
                        separator=":: "
                      >
                        <FaWhatsapp size={32} color="#9F4701" />
                      </WhatsappShareButton>

                      <FacebookShareButton url={pageUrl}>
                        <FaFacebook size={32} color="#9F4701" />
                      </FacebookShareButton>

                      <TwitterShareButton url={pageUrl}>
                        <FaTwitter size={32} color="#9F4701" />
                      </TwitterShareButton>

                      <LinkedinShareButton url={pageUrl}>
                        <FaLinkedin size={32} color="#9F4701" />
                      </LinkedinShareButton>
                      <EmailShareButton string="" url={pageUrl}>
                        <GrMail size={32} color="#9F4701" />
                      </EmailShareButton>
                    </Box>
                  </Box>
                </Box>
              )}
              {/* rightboxends */}
            </Box>
            <Box
              display={{ base: 'block', lg: 'none' }}
              // width={{ base: '3rem', md: '5.313rem', lg: '7.4375rem' }}
              zIndex="20"
              float="right"
            >
              <Icon
                width="236px"
                height="42px"
                viewBox="0 0 236px 42px"
                fill="none"
              >
                <g opacity="0.4" clip-path="url(#clip0_5115_25508)">
                  <path
                    d="M84.9914 42.0129C84.8183 41.1145 84.6368 40.2164 84.4772 39.3158C84.405 38.9128 84.1084 37.1264 84.0474 37.0811C83.9863 37.0359 82.0327 37.0355 82.0078 37.0524C81.9829 37.0692 82.2935 39.7232 82.3275 40.6765C82.1585 40.7944 81.9894 40.9122 81.8203 41.0301C81.7546 40.8068 80.727 36.8665 80.6987 36.8341C80.6704 36.8017 76.567 36.5422 74.9962 36.3696C73.1713 36.1682 71.3618 35.8286 69.5404 35.583C65.7901 35.0766 62.0424 34.5507 58.2842 34.1099C54.1353 33.6228 50.041 34.2364 45.9926 35.0864C41.8126 35.9627 37.652 36.9548 33.5088 38.0062C30.8454 38.6814 25.8302 39.3826 21.938 38.4724C18.0441 37.5623 15.1938 33.6729 15.1556 30.3235C15.1365 28.6955 15.2968 27.0481 15.5519 25.4393C16.0885 22.0566 17.7381 14.1672 17.9921 13.6208C18.0677 13.4554 18.2811 13.3888 18.4639 13.2757C18.6255 13.4246 18.7668 13.6237 18.8074 13.855C18.9668 14.7504 18.8089 15.6089 18.9677 16.582C19.3546 18.9489 20.1875 20.9117 21.2649 22.916C22.2512 24.7528 23.5952 26.4713 23.4892 28.7818C23.4468 29.6869 23.0572 30.1452 22.2711 30.5857C21.5099 31.011 20.5691 31.0659 19.7376 30.9011C18.9061 30.7363 18.331 30.1415 17.9717 29.2134C17.5543 28.1341 17.4637 27.1213 17.9095 26.0467C17.9923 25.844 18.1401 25.607 18.2794 25.6085C18.4188 25.6101 18.6181 25.8616 18.681 26.055C18.9381 26.8301 18.8869 28.1555 19.405 28.7738C20.1378 29.6448 21.1631 29.3396 21.6682 28.8802C22.1734 28.4209 22.091 26.7831 21.4145 25.5834C20.5984 24.137 19.3349 22.6288 18.2205 21.203C18.2205 21.203 17.9345 21.9466 17.8875 22.0561C16.7866 24.5735 15.775 27.0698 15.9638 29.9774C16.1747 33.2159 18.2292 35.5645 20.8444 36.6787C23.7356 37.9108 26.8416 37.6892 29.7947 37.3254C33.6189 36.8548 37.4189 35.9476 41.1462 34.9038C45.5412 33.6731 49.9718 32.8204 54.5044 32.733C57.3208 32.6781 60.1586 32.8447 62.9608 33.1539C66.1826 33.51 69.3728 34.1709 72.5863 34.6297C74.9614 34.9681 77.3514 35.1984 79.7374 35.4622C79.8534 35.4753 80.5818 35.5594 80.6135 35.5423C80.6451 35.5252 80.4341 32.5196 80.3901 32.4772C80.3461 32.4349 79.4759 32.471 79.3008 32.4674C77.1907 32.4149 66.391 31.6878 62.9021 29.6094C59.769 27.7411 58.0905 24.5059 58.8496 19.6498C59.2328 17.2048 59.964 14.8008 60.7344 12.4464C61.2704 10.8053 61.4421 9.14685 61.6062 7.46225C61.6357 7.14875 61.7984 6.85116 61.8996 6.54542C62.0988 6.79694 62.3751 7.01717 62.4823 7.30586C63.2453 9.3579 63.4109 11.8518 64.9339 14.3978C66.5944 17.1749 67.9481 20.3082 68.0284 21.745C68.1087 23.1835 67.7512 24.3057 66.838 25.0865C65.9429 25.8506 64.5344 25.7052 64.0296 25.5063C62.9096 25.0653 62.234 23.8427 61.9481 22.7353C61.6622 21.6278 61.8896 20.1472 62.4927 19.4369C62.7047 19.1868 63.244 18.9731 63.5416 19.1237C63.8201 19.2645 63.9271 19.7384 63.8992 20.0519C63.8003 21.1339 63.7221 22.6069 64.0392 23.2561C64.3563 23.9053 65.4699 24.2142 65.9049 23.3147C66.3399 22.4152 66.2787 20.7007 65.713 19.5143C65.1621 18.3591 62.6309 14.4606 62.5735 14.47C62.5161 14.4793 60.2293 18.42 60.1354 21.1165C60.0415 23.8129 60.6006 25.6736 61.7686 26.935C62.9366 28.1964 64.2654 28.9203 65.676 29.5068C67.5177 30.2739 73.7623 31.077 74.8855 31.1791C76.3443 31.3102 77.8124 31.3669 79.2781 31.4025C79.6946 31.4125 80.3266 31.4139 80.3569 31.3563C80.3871 31.2986 80.378 30.7114 80.3507 30.2325C80.3065 29.4719 80.1709 28.7185 80.0776 27.9617C80.0444 27.7001 79.9478 27.4198 80.002 27.1777C80.1148 26.6738 80.3081 26.1898 80.4672 25.6964C80.7204 26.0782 81.0102 26.4408 81.2185 26.849C81.5765 27.5513 81.9076 28.2581 81.4085 29.0772C81.2785 29.2888 81.5153 31.3528 81.5594 31.3987C81.6035 31.4446 83.7735 31.2706 83.8007 31.2254C83.828 31.1802 83.8329 30.603 83.8322 30.4425C83.8271 29.5375 83.6623 28.6352 83.6215 27.7298C83.5959 27.1556 83.6531 26.571 83.7295 25.9998C83.7509 25.8384 83.9829 25.5786 84.0971 25.59C84.2796 25.6093 84.5251 25.776 84.6009 25.9495C84.7505 26.2859 84.8695 26.6676 84.8826 27.0341C84.9182 28.0315 84.886 29.0315 84.8945 30.0299C84.8941 30.5417 84.9086 31.1834 84.962 31.2519C85.0154 31.3203 85.571 31.2754 86.0805 31.2235C89.2559 30.9021 92.4399 30.6298 95.5946 30.1539C98.2711 29.7499 100.901 29.0319 103.57 28.5594C107.243 27.9077 110.931 27.3296 114.619 26.7726C117.387 26.3544 120.16 25.9413 122.943 25.6742C125.076 25.4699 127.229 25.4413 129.375 25.4323C131.408 25.4225 133.449 25.4442 135.473 25.6218C138.762 25.91 142.042 26.3221 145.323 26.7076C149.083 27.1501 152.839 27.621 156.596 28.0777C156.896 28.1135 160.021 28.3888 162.431 27.7924C164.288 27.3325 165.568 26.0044 165.733 25.8319C166.162 25.3862 166.729 24.6474 166.719 24.6001C166.715 24.5809 165.335 23.582 164.544 22.7786C163.324 21.5387 162.425 20.159 161.728 18.8649C160.143 15.919 159.772 12.6533 159.987 10.4126C160.135 8.88568 160.514 7.38137 160.825 5.66451C161.115 5.93714 161.502 6.12123 161.577 6.39886C162.161 8.53737 163.768 9.90492 165.011 11.5604C165.51 12.2253 166.427 13.7719 166.564 15.1746C166.694 16.5034 166.268 17.5985 165.745 17.8468C164.923 18.2375 163.942 17.6798 163.442 17.0008C162.942 16.3218 162.699 15.1897 162.439 14.3301C162.393 14.1801 162.586 13.786 162.586 13.786C162.586 13.786 162.978 13.8729 163.082 13.9994C163.256 14.2131 163.489 14.9379 163.849 15.319C164.163 15.6506 164.535 15.7771 164.797 15.6891C165.058 15.6011 165.274 15.2308 165.306 14.7761C165.346 14.1887 164.955 13.4736 164.778 13.2177C163.855 11.8831 162.789 10.653 161.695 9.27751C161.554 9.34305 161.163 10.1755 161.059 10.9366C160.853 12.45 161.061 14.5434 161.539 15.7967C162.202 17.5404 163.598 20.0862 165.149 21.7083C166.053 22.6537 167.33 23.4149 167.35 23.407C167.414 23.3868 167.662 22.463 167.739 21.9094C167.922 20.5893 167.99 19.2102 167.845 17.889C167.764 17.1546 167.422 14.3784 167.851 12.0639C168.315 9.55929 169.56 7.52666 169.643 7.35049C170.171 6.22496 171.28 4.24188 171.929 2.59456C172.353 1.52082 172.456 0.498602 172.5 0.265688C172.616 0.275226 172.888 0.585595 172.908 0.708337C173.149 2.264 174.254 4.86188 175.077 6.86745C175.726 8.44931 176.149 9.66958 176.176 9.67732C176.238 9.69429 176.777 9.53003 177.294 9.34726C179.433 8.59393 181.559 7.8023 183.694 7.03852C183.862 6.97895 184.058 7.00648 184.241 6.99219C184.254 7.21049 184.256 7.46802 184.172 7.63369C183.966 8.03712 183.996 10.014 183.766 11.7189C183.564 13.2285 183.13 14.8215 183.133 14.8248C183.137 14.8282 184.734 15.5997 185.143 15.7918C186.88 16.6089 189.688 16.7962 190.689 16.3507C190.788 16.3062 190.911 16.3137 191.023 16.3128C191.074 16.3126 191.124 16.3529 191.228 16.4C191.037 17.1257 190.644 17.5983 189.899 17.7601C189.321 17.8853 187.821 17.9428 186.37 17.5961C184.648 17.1842 182.898 16.3164 182.871 16.3298C182.844 16.3432 181.368 19.329 180.056 19.9332C179.183 20.3347 178.357 20.5226 177.404 19.7875C176.67 19.2236 176.31 18.0467 176.61 17.2143C177.145 15.7356 178.175 15.0491 179.717 14.8434C180.661 14.7179 181.751 14.6907 181.833 14.6274C181.916 14.5642 182.527 12.5478 182.643 11.705C182.775 10.7452 182.738 9.09852 182.686 9.05648C182.633 9.01444 182.048 9.17522 181.708 9.26629C180.151 9.67898 178.599 10.1197 177.066 10.6197C176.955 10.6559 176.518 10.7914 176.491 10.8506C176.465 10.9099 176.718 12.8657 176.479 14.5073C176.306 15.7017 174.803 17.6016 173.648 17.5096C172.339 17.4061 171.233 16.0699 171.218 14.5971C171.208 13.6552 171.942 12.1863 173.064 11.1944C173.755 10.583 175.051 10.1453 175.051 10.1453C175.051 10.1453 174.932 9.66826 174.838 9.40025C174.452 8.30381 173.793 6.34826 173.268 5.12673C173.014 4.5368 172.718 4.1497 172.642 4.05743C172.438 4.71134 171.893 6.1516 171.564 6.82634C171.301 7.36433 169.781 9.73957 169.269 12.3431C168.759 14.9466 169.258 17.7803 169.32 18.5172C169.367 19.0835 169.358 20.3526 169.2 21.4917C169.03 22.716 168.708 23.7962 168.724 23.8256C168.741 23.855 170.871 24.5719 173.111 24.351C175.279 24.1382 177.549 22.9915 178.215 22.7534C180.964 21.7678 183.76 21.2072 186.699 21.5463C187.723 21.6647 188.781 21.4111 189.824 21.4016C190.155 21.3991 190.489 21.6347 190.822 21.7627C190.659 22.1591 190.596 22.7739 190.314 22.9157C189.108 23.5192 188.425 24.6155 187.568 25.5882C186.206 27.1331 184.705 28.5388 182.663 29.1542C181.191 29.5988 179.673 29.3694 178.683 28.4468C177.695 27.5242 177.853 25.9951 178.223 25.5552C178.593 25.1154 179.458 24.3065 180.228 24.5567C180.499 24.6447 180.861 25.1704 180.855 25.2306C180.848 25.2909 179.52 26.3968 179.485 26.7847C179.429 27.4063 179.993 27.6998 180.579 27.7772C182.14 27.9802 183.505 27.4657 184.632 26.3836C185.543 25.5076 186.352 24.5157 187.186 23.5581C187.323 23.4009 187.845 22.7927 187.845 22.7927C187.845 22.7927 186.852 22.5232 184.857 22.5579C182.901 22.5911 179.772 23.7312 177.131 25.0037C176.336 25.3863 174.47 25.9701 172.688 26.0599C170.717 26.159 167.962 25.368 167.917 25.3874C167.895 25.3971 167.539 26.0111 166.882 26.6123C165.849 27.5584 164.191 28.681 162.811 28.9649C159.7 29.6032 155.857 29.1763 155.355 29.1079C151.497 28.5828 147.643 28.0311 143.781 27.5397C141.96 27.3082 140.127 27.123 138.295 27.0402C134.859 26.883 131.42 26.7137 127.984 26.7402C125.06 26.7622 122.127 26.9487 119.215 27.2492C115.955 27.5845 112.714 28.115 109.469 28.5891C106.871 28.967 94.0998 31.3477 90.248 31.7558C88.7333 31.9163 87.2215 32.1119 85.7046 32.2583C85.4862 32.2793 85.0413 32.2845 85.0064 32.3053C84.9715 32.3261 84.9848 32.7456 84.9881 33.0278C84.9901 33.0859 84.9906 33.1459 84.991 33.2041C84.9931 34.5469 85.1296 35.7061 85.1581 35.742C85.1866 35.778 86.4094 35.8637 87.5059 35.8874C90.4404 35.9514 93.3795 35.957 96.3119 35.8217C99.3562 35.6819 102.748 35.5231 105.792 35.3234C107.211 35.2302 110.605 35.1013 113.669 34.7032C116.38 34.3507 118.802 33.7309 119.791 33.5418C121.958 33.1297 124.109 32.5682 126.292 32.3302C128.505 32.0892 133.178 31.5551 137.208 31.4205C140.489 31.3101 143.329 31.5667 144.199 31.6417C147.49 31.928 150.779 32.2603 154.062 32.6282C156.646 32.9177 159.22 33.303 161.802 33.6209C164.547 33.9588 167.297 34.2772 170.045 34.5885C171.207 34.7208 174.675 35.2189 178.578 35.4881C183.532 35.8305 189.191 35.9456 191.766 36.0202C195.793 36.1363 199.669 35.1149 203.538 34.0991C206.196 33.4011 208.863 32.7311 211.538 32.1188C212.28 31.9484 217.582 30.7806 222.996 30.6142C226.968 30.4925 231.276 31.305 232.497 31.4597C234.734 31.7436 236.947 32.2155 239.173 32.5898C242.316 33.1185 245.478 33.0164 248.644 32.9301C249.367 32.9103 250.095 33.028 250.82 33.084C250.825 33.2197 250.832 33.3535 250.838 33.4892C250.52 33.5864 250.205 33.7559 249.885 33.7686C247.115 33.8781 244.339 34.1131 241.576 33.9982C239.449 33.9094 237.341 33.3486 235.22 33.0372C234.281 32.8997 232.074 32.4611 229.874 32.2286C227.881 32.0163 225.892 31.9978 224.856 32.0441C221.742 32.1849 218.435 32.8291 217.476 32.987C215.482 33.3146 208.843 34.9376 207.487 35.2188C206.19 35.4871 197.475 37.2397 194.391 37.404C190.856 37.5932 187.292 37.7076 183.741 37.2498C181.141 36.9149 178.514 36.8229 175.903 36.5944C174.132 36.4385 172.366 36.2243 170.598 36.0524C169.086 35.9057 167.57 35.7945 166.058 35.646C163.672 35.4122 161.285 35.1695 158.899 34.9162C156.766 34.69 154.632 34.4637 152.503 34.202C150.432 33.9487 145.257 33.3362 142.988 33.1912C140.718 33.0463 135.661 33.0486 133.465 33.1089C131.235 33.1706 128.997 33.2467 126.78 33.4949C124.145 33.7896 121.528 34.2655 118.904 34.6762C116.595 35.0375 114.296 35.5042 111.974 35.753C110.514 35.9096 107.098 36.0799 104.208 36.3124C101.32 36.5465 86.7724 37.0369 86.3085 37.0341C85.8446 37.0313 85.321 37.022 85.2935 37.0601C85.266 37.0983 85.2939 37.6883 85.3127 38.0722C85.3575 39.041 85.4006 40.0098 85.4064 40.9783C85.4085 41.3241 85.3003 41.6707 85.2413 42.0153C85.1562 42.0117 85.0712 42.0097 84.9861 42.006L84.9914 42.0129ZM173.115 16.0167C173.384 16.1578 173.938 15.9947 174.158 15.7567C174.727 15.136 175.132 14.2165 175.302 13.1246C175.411 12.418 175.386 11.3002 175.364 11.2834C175.346 11.27 174.495 11.743 174.145 12.0374C173.705 12.4078 172.82 13.2774 172.557 14.3201C172.346 15.156 172.681 15.7851 173.117 16.0149L173.115 16.0167ZM177.823 18.3434C177.918 18.9201 178.462 19.038 179.047 18.8879C179.755 18.7081 180.342 17.8097 180.642 17.4184C180.94 17.0273 181.378 16.2935 181.356 16.2609C181.335 16.2282 179.967 16.2611 179.384 16.4482C178.413 16.7619 177.695 17.5649 177.823 18.3434ZM83.8555 32.5202C83.8449 32.5101 81.7286 32.5196 81.6874 32.5548C81.6462 32.5899 81.807 35.6169 81.8407 35.6579C81.8745 35.6989 83.9169 35.7117 83.9479 35.6769C83.9789 35.6422 83.8678 32.5303 83.8554 32.5185L83.8555 32.5202Z"
                    fill="#010509"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5115_25508">
                    <rect
                      width="40.7033"
                      height="250.305"
                      fill="white"
                      transform="matrix(1.18918e-08 -1 0.999997 0.00246385 0 41.0234)"
                    />
                  </clipPath>
                </defs>
              </Icon>
            </Box>
            {/* box 2 ends here */}
          </Box>
        </Box>

        {/* kolams */}

        <Box
          display={{ base: 'none', lg: 'block' }}
          width={{ base: '3rem', md: '5.313rem', lg: '8.056875rem' }}
          height={{ base: '10rem', md: '', lg: '30%' }}
          position="absolute"
          top={{ base: '-1rem', md: '-10rem', lg: '0' }}
          zIndex="20"
          // left={{ base: '3.5rem', md: '10rem', lg: '2.5rem' }}
          left="0"
          transform={{ base: 'rotate(270deg)', lg: 'rotate(360deg)' }}
        >
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1718963233-colam-flowers-origin.png`}
            alt="flower image"
          />
        </Box>

        <Box
          display={{ base: 'none', lg: 'block' }}
          width={{ base: '3rem', md: '5.313rem', lg: '7.4375rem' }}
          zIndex="20"
          height={{ base: '10rem', md: '25rem', lg: '49.6875rem' }}
          position="absolute"
          bottom={{
            lg: '10%',
            md: '-9rem',
            base: '0',
            xl: '18%',
            '2xl': '15%',
          }}
          right="0"
          transform={{ base: 'rotate(92.22deg)', lg: 'rotate(180deg)' }}
        >
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1718963233-colam-flowers-origin.png`}
            alt="flower image"
          />
        </Box>
      </Box>
    </>
  );
};

export default ProgramDetails;
